import { render, staticRenderFns } from "./NotasMovidas.vue?vue&type=template&id=51dc04b6"
import script from "./NotasMovidas.vue?vue&type=script&lang=js"
export * from "./NotasMovidas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports